(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('ModuleService', ModuleService)

    /** @ngInject */
    function ModuleService(HttpService) {
        const ModuleService = {
            getAll: getAll
        }

        return ModuleService;

        function getAll(onlySearch = null) {
            let url = 'portal';

            if (onlySearch)
                url = url.concat(`?search=true`)

            return HttpService.get(`/modules/${url}`);
        }
    }
}());